import { useLocation } from 'react-router';
import { Moon, Sun } from 'lucide-react';
import { UserMenu } from './user-menu';
import { CompanySwitcher } from './company-switcher';
import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';

const routeTitles: Record<string, string> = {
  '/': 'Inicio',
  '/courses': 'Mi Capacitación',
  '/documents': 'Documentos',
  '/documents/readings': 'Lecturas',
  '/certificates': 'Mis Certificados',
  '/competency': 'Mi Competencia',
  '/notifications': 'Notificaciones',
  '/external-trainings': 'Capacitaciones Externas',
  // Instructor
  '/instructor/courses': 'Mis Capacitaciones',
  '/instructor/enrollments': 'Inscripciones',
  '/instructor/quiz-grading': 'Calificar Quizzes',
  '/instructor/evidence-review': 'Revisar Evidencias',
  '/instructor/complete-lessons': 'Completar Practicas',
  '/instructor/reports': 'Reportes',
  '/instructor/corrective-actions': 'Acciones Correctivas',
  // Supervisor
  '/supervisor/team': 'Mi Equipo',
  '/supervisor/changes': 'Aprobar ICNs',
  '/supervisor/assessments': 'Evaluaciones',
  '/supervisor/declarations': 'Declaraciones',
};

export function Header({ leftAction }: { leftAction?: ReactNode }) {
  const location = useLocation();
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'));

  const title = routeTitles[location.pathname] ?? 'Mi Portal';

  const toggleTheme = () => {
    const next = !isDark;
    setIsDark(next);
    document.documentElement.classList.toggle('dark', next);
    localStorage.setItem('theme', next ? 'dark' : 'light');
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-card px-4 sm:px-6">
      <div className="flex items-center gap-2">
        {leftAction}
        <h1 className="text-lg font-semibold text-foreground">{title}</h1>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={toggleTheme}
          className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
          aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
        >
          {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </button>
        <CompanySwitcher />
        <UserMenu />
      </div>
    </header>
  );
}
